<div class="row">
    <div class="col-12 responsive-partial-overflow-swiper">
        <swiper [config]="responsivePartialOverflowConfig" (swiper)="onWhyStudySwiper($event)" class="w-100 why-swiper">
            <ng-template swiperSlide *ngFor="let slide of slides">
                <div class="w-100 h-100 d-flex flex-column">
                    <div class="card h-100 shadow-sm flex-grow-1">
                        <div class="card-img-top pt-5" >
                            <img loading="lazy" [src]="slide?.icon" [alt]="slide.icon_alt ? slide.icon_alt : slide.title" class="img-fluid d-block mx-auto"
                                 style="max-height: 150px; position: relative; z-index: 2;" />
                        </div>
                        <div class="card-body pt-0">
                            <h4 class="text-center mx-auto d-block text-dark font-size-18 mt-0" style="_height: 45px;">{{ slide?.title }}</h4>
                            <p class="text-center mt-5 font-size-14 text-dark" [innerHTML]="slide.description | safeHtml"></p>
                        </div>
                    </div>
                </div>
            </ng-template>
        </swiper>
    </div>
</div>